<!--
 * @Description: 系统应用数量统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 17:05:20
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 09:28:43
 -->
<template>
  <div class="connectDeviceStatics">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">接入设备数量统计</span>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in connectDeviceData" :key="index">
        <span class="title">{{item.productName}}</span>
        <el-progress :percentage="item.number * 100 / connectDeviceData[0].number" :color="item.color" :format="progressFormat(item.number)"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'connectDeviceStatics',
  components: {
  },
  data () {
    return {
      connectDeviceData: [],
      colors: ['#ff8400', '#ffff00', '#00ff00', '#03f7f7', '#03f7f7', '#03f7f7'],
    }
  },
  methods: {
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/home/device/summary')
        .then(res => {
          if (res.code === 0) {
            let data = res.data
            data.map((item, index) => {
              item.color = this.colors[index] ? this.colors[index] : '#03f7f7'
            })
            this.connectDeviceData = data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   进度条内容格式化
     * @param                         内容
     * @return {undefied}             无返回值
     */
    progressFormat (value) {
      return () => {
        return value.toString()
      }
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .connectDeviceStatics {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 4vh;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      position: relative;
      >img {
        height: 100%;
        margin-right: 20px;
      }
      .titleName {
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5vh;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #05dbe3;
      }
    }
    .list {
      width: 100%;
      height: 85%;
      overflow-y: scroll;
      .item {
        width: 100%;
        height: 16.66%;
        display: flex;
        align-items: center;
        .title {
          display: inline-block;
          width: calc(35% - 20px);
          padding-right: 10px;
          color: #fff;
          vertical-align: middle;
          font-size: 1.5vh;
          text-align: right;
        }
        /deep/.el-progress {
          display: inline-block;
          width: 65%;
          .el-progress-bar {
            .el-progress-bar__outer {
              background: #1b3134;
            }
          }
          .el-progress__text {
            color: #fff;
          }
        }
      }
    }
  }
</style>
